// import qs from 'qs'

export default class HttpBase {
  constructor(config = {}) {
    const { getToken, errorCallback, dataFetcher, getOriginRouter } = config
    // this.getToken = store.getToken
    this.config = config

    this.getToken = getToken
    this.getOriginRouter = getOriginRouter || null
    this.dataFetcher = dataFetcher
    this.errorCallback = errorCallback || {}
  }

  // eslint-disable-next-line class-methods-use-this
  get http() {
    return fetch
  }

  setErrorCallback(cbs) {
    this.errorCallback = { ...this.errorCallback, ...cbs }
  }

  ensureToken(originUrl, config = { searchParams: {} }) {
    // const [search] = originUrl.split('?')

    const data = {
      // ...qs.parse(search),
      ...config.json,
      ...config.searchParams,
    }

    const token = this.getToken()
    const url = `${originUrl}${
      originUrl.indexOf('?') > 0 ? '&' : '?'
    }token=${token}`
    return {
      url,
      data,
      ...config,
    }
  }
}
